// assets

import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'; // constant
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
const icons = { PeopleAltOutlinedIcon, WorkHistoryOutlinedIcon, WorkOutlineIcon, FlightTakeoffIcon, FileDownloadOutlined };
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const employementFeatures = {
    id: 'adminFeatures',
    title: 'Employement',
    type: 'group',
    children: [
        {
            id: 'employees',
            title: 'Employee Information',
            type: 'item',
            url: '/admin/employees',
            icon: icons.PeopleAltOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'employees-attendance',
            title: 'Attendance',
            type: 'item',
            url: '/admin/attendances',
            icon: icons.WorkHistoryOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'leave',
            title: 'Leave Request',
            type: 'item',
            url: '/admin/leave',
            icon: icons.FlightTakeoffIcon,
            breadcrumbs: false
        },
        {
            id: 'export-request',
            title: 'Export History',
            type: 'item',
            url: '/admin/export-request',
            icon: icons.FileDownloadOutlined,
            breadcrumbs: false
        }
    ]
};

export default employementFeatures;
